import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { EnvironmentConfig } from "../models/environment-config.model";
import { ToastrService } from "ngx-toastr";
import { LogService } from "./log.service";

declare var environment: EnvironmentConfig;

@Injectable({
  providedIn: "root",
})
export class ErrorsHandler implements ErrorHandler {
  constructor(private injector: Injector, private logService: LogService) {}

  handleError(error: Error, componentOrServiceName: string = "") {
    const httpError = this.asHttpError(error);
    if (httpError) {
      // Server or connection error happened
      if (!navigator.onLine) {
        console.error("you are offline my dude");
        return;
      }

      // Resource 401s (no Connect lead, missing phone claim, not allowed) must not
      // end the identity session. ApiUnauthorizedInterceptor confirms a 401 with
      // Identity userinfo before it clears the oidc user.
      if (httpError.status === 401) {
        return;
      }

      const validationErrors = [];
      for (const fieldName in httpError.error) {
        if (httpError.error.hasOwnProperty(fieldName) && Array.isArray(httpError.error[fieldName])) {
          validationErrors.push(httpError.error[fieldName][0]);
        }
      }

      if (validationErrors.length === 0 && typeof httpError.error === "string") {
        validationErrors.push(httpError.error);
      }

      for (const fieldName in httpError.error?.errors) {
        if (httpError.error.errors.hasOwnProperty(fieldName) && Array.isArray(httpError.error.errors[fieldName])) {
          validationErrors.push(httpError.error.errors[fieldName][0]);
        }
      }

      const toastrService = this.injector.get(ToastrService);
      if (httpError.status === 403) {
        toastrService.error("Unauthorized, contact support.", "", { enableHtml: true });
        return;
      }

      // for admin we want to always show errors even if they are ugly
      toastrService.error(validationErrors.join("<br/><br/>"), `${httpError.status} - ${httpError.statusText}`, {
        enableHtml: true,
      });
    }

    this.logService.error(componentOrServiceName, error);

    //https://stackoverflow.com/questions/56496296/how-do-i-fix-firestore-sdk-hitting-an-internal-error-was-encountered-in-the-ind/56496297#56496297
    if (error?.message?.includes("Indexed Database server")) {
      window.location.reload();
    }
  }

  private asHttpError(error: any): HttpErrorResponse | null {
    if (error instanceof HttpErrorResponse) {
      return error;
    }

    if (error?.rejection instanceof HttpErrorResponse) {
      return error.rejection;
    }

    return null;
  }
}
